import { useChooseContext } from "../context/ChooseContext";
import { useMapContext } from "../context/MapContext";
import { useSelectEarthquakeContext } from "../context/SelectEarthquakeContext";
import { useShrinkContext } from "../context/ShrinkContext";

export default function RecentEarthquake() {
  const [state] = useShrinkContext();
  const [stateRecent] = useSelectEarthquakeContext();
  const [map] = useMapContext();
  const [, dispatch] = useChooseContext();

  const onClickRecentHandler = (e) => {
    e.preventDefault();
    dispatch({ type: "recent" });
    if (!stateRecent.isLoading)
      map.flyTo(
        [
          stateRecent.recentEarthquake.Position[0],
          stateRecent.recentEarthquake.Position[1],
        ],
        9
      );
  };

  return (
    <>
      {stateRecent.isLoading ? (
        ""
      ) : (
        <div
          className={
            state.shrink ? "recent-earthquake-top-right" : "recent-earthquake"
          }
          onClick={(e) => onClickRecentHandler(e)}
        >
          GEMPA TERBARU
        </div>
      )}
    </>
  );
}
